<template>
    <b-card-body>
        <b-form-row class="filter-row" @keyup.enter="load">
            <b-col md="4" lg="3">
                <LgFinderPageUnidadeAdministrativa id="unidadeDetalhaMonitoramento" :prefix="prefix + title + ' > '"
                    v-model="form.departamento" label="Departamento:" required
                    @onselect="handleSelectUnidadeAdministrativa" />
            </b-col>

            <b-col md="4" lg="3">
                <LgFinderPageLocalArmazenamento id="localDetalhaMonitoramento" :prefix="prefix + title + ' > '"
                    v-model="form.local" label="Local Armazenamento:" required @input="handleLocal" />
            </b-col>

            <b-col md="4" lg="3">
                <LgFinderPageLeitor id="leitorDetalhaMonitoramento" :prefix="prefix + title + ' > '"
                    v-model="form.leitor" label="Leitor:" required @close="handleLeitor" />
            </b-col>
        </b-form-row>

        <div class="d-flex align-items-center mb-3">
            <b-button size="sm" variant="primary" class="mr-2" @click="load">
                <b-icon icon="search" class="mr-1" />
                Buscar
            </b-button>
            <b-link class="text-muted small" href="#" @click.prevent="limpar">
                <b-icon icon="x-circle" class="mr-1" />
                Limpar filtros
            </b-link>
        </div>

        <b-alert v-if="loadError" show variant="danger" dismissible class="mb-3" @dismissed="loadError = ''">
            {{ loadError }}
        </b-alert>

        <b-table responsive :busy="busy" :items="records" :fields="tableFields"
            bordered hover show-empty>
            <template #empty>
                <p>Nenhum registro encontrado</p>
            </template>

            <template #table-busy>
                <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                </div>
            </template>

            <template #cell(expand)="row">
                <b-button @click="row.toggleDetails" variant="outline-primary" size="sm">
                    <b-icon :icon="row.detailsShowing ? 'dash-lg' : 'plus-lg'" />
                </b-button>
            </template>

            <template #row-details="row">
                <ul class="list-group list-group-flush w-100">
                    <li v-for="(antena, index) in row.item.antenas" :key="index"
                        class="list-group-item">
                        <b-row class="align-items-center">
                            <b-col md="2" class="mb-2 mb-md-0">
                                <strong>Antena {{ index + 1 }}</strong>
                            </b-col>

                            <b-col md="3" class="mb-2 mb-md-0">
                                <b-form-group label="Nome:" label-size="sm" class="mb-0">
                                    <b-form-input @blur="onBlurDescricao(row.item.codLeitor, index, antena.descricao)"
                                        size="sm" type="text" v-model="antena.descricao" />
                                </b-form-group>
                            </b-col>

                            <b-col md="3" class="mb-2 mb-md-0">
                                <lg-form-const-select sm="12" md="12" label="Tipo de Antena:" v-model="antena.tipoAntena"
                                    :options="optionsTipoAntenas" :disabled="antena.situacao == 0"
                                    @change="mudarTipoAntena(row.item.codLeitor, index, antena.tipoAntena)" />
                            </b-col>

                            <b-col md="2" class="mb-2 mb-md-0">
                                <small class="text-muted d-block mb-1">Potência</small>
                                <input :disabled="antena.situacao == 0" type="range" class="form-range" min="0"
                                    max="30" v-model="antena.potencia"
                                    @change="onPotenciaChange(row.item.codLeitor, index, antena.potencia)" />
                            </b-col>

                            <b-col md="2" class="d-flex align-items-center justify-content-md-end">
                                <b-icon :id="`antena-${row.index}-${index}`" icon="broadcast"
                                    :variant="antena.situacao ? 'primary' : 'danger'" font-scale="1.4" />
                                <b-tooltip :target="`antena-${row.index}-${index}`"
                                    :title="antena.situacao == 1 ? 'Disponível' : 'Indisponível'"></b-tooltip>

                                <b-button :id="`${row.index}-${index}-historico-button-antena`" class="ml-2" size="sm"
                                    variant="outline-primary" @click="abrirModalHistoricoAntena(row.item, antena)">
                                    <b-icon icon="list" />
                                </b-button>
                                <b-tooltip :target="`${row.index}-${index}-historico-button-antena`"
                                    title="Histórico de leitura"></b-tooltip>
                            </b-col>
                        </b-row>
                    </li>
                </ul>
            </template>
        </b-table>

        <div class="pagination-bar">
            <small class="text-muted">
                Página {{ page }} de {{ totalPage }} &mdash; {{ total }} registros
            </small>
            <div class="d-flex align-items-center">
                <small class="text-muted mr-2">Por página:</small>
                <b-form-select size="sm" v-model="perPage" @change="onPerPageChange"
                    :options="perPageOptions" style="width: 70px" />
            </div>
            <b-pagination size="sm" v-model="page" :per-page="perPage" :total-rows="total"
                class="mb-0" />
        </div>

        <ModalHistoricoLeituraLeitor :prefix="prefix + title + ' > '" v-if="showModalHistorico"
            @fecharModal="fecharModalLeitor" :antena="antena" :leitor="leitor"></ModalHistoricoLeituraLeitor>
    </b-card-body>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";
import LgFinderPageLeitor from "@/components/Finders/LgFinderPageLeitor.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm"
import ModalHistoricoLeituraLeitor from "@/modules/cadastros/leitor/ModalHistoricoLeituraLeitor.vue"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";

export default {
    components: {
        LgFormConstSelect,
        ModalHistoricoLeituraLeitor,
        LgFinderPageLeitor,
        LgFinderPageLocalArmazenamento,
        LgFinderPageUnidadeAdministrativa
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
    },

    mixins: [ListResourceMixin, ConfirmMixin],
    computed: {
        tableFields() {
            return [
                { key: "expand", label: "", thStyle: { width: "50px" } },
                { key: "departamento", label: "Departamento" },
                { key: "local", label: "Local Armazenamento" },
                { key: "leitor", label: "Leitor" },
            ];
        },
    },

    data() {
        return {
            title: "Monitoramento rfid - Antenas",
            showModalHistorico: false,
            loadError: "",
            optionsTipoAntenas: [
                { key: "filtertipoAntena", text: "Saída oficial", value: 1 },
                { key: "filtertipoAntena", text: "Interna", value: 2 },
            ],

            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: {},
            antena: {},
            leitor: {},
            form: {
                departamento: {},
                local: {},
                leitor: {}
            },

        }
    },
    methods: {
        async onBlurDescricao(leitor, antena, descricao) {
            if (!descricao) descricao = " ";
            try {
                await this.$leitorService.put(`${leitor}/${antena}/${descricao}/descricao`, {});
            } catch (error) {
                this.$notify({ type: "danger", message: "Não foi possível salvar a descrição da antena." });
            }
        },

        fecharModalLeitor() {
            this.antena = null;
            this.leitor = null;
            this.showModalHistorico = false;
        },
        abrirModalHistoricoAntena(leitor, antena) {
            this.antena = antena.id;
            this.leitor = leitor.codLeitor;
            this.showModalHistorico = true;
        },
        async mudarTipoAntena(leitor, antena, tipoAntena) {
            try {
                await this.$leitorService.put(`${leitor}/${antena}/${tipoAntena}/tipo-antena`, {});
            } catch (error) {
                this.$notify({ type: "danger", message: "Não foi possível alterar o tipo da antena." });
            }
        },
        async onPotenciaChange(leitor, antena, potencia) {
            try {
                await this.$leitorService.put(`${leitor}/${antena}/${potencia}/potencia`, {});
            } catch (error) {
                this.$notify({ type: "danger", message: "Não foi possível alterar a potência da antena." });
            }
        },
        handleLeitor(leitor) {
            this.form.leitor = leitor || {};
            this.load();

        },
        handleLocal(local) {
            this.form.local = local || {};
            this.load();

        },
        handleSelectUnidadeAdministrativa(departamento) {
            this.form.departamento = departamento || {};
            this.load();
        },

        limpar() {
            this.form.departamento = {};
            this.form.local = {};
            this.form.leitor = {};
            this.page = 1;
            this.load();
        },
        onPerPageChange() {
            this.page = 1;
            this.load();
        },

        async load() {
            this.filtro = {};
            this.busy = true;
            this.loadError = "";

            try {
                if (this.form.departamento && this.form.departamento.id)
                    this.filtro.departamento = this.form.departamento.id;

                if (this.form.local && this.form.local.id)
                    this.filtro.local = this.form.local.id;

                if (this.form.leitor && this.form.leitor.id)
                    this.filtro.leitor = this.form.leitor.id;

                await this.$loadResource({
                    size: this.perPage,
                    page: this.page,
                    params: this.filtro,
                });
            } catch (error) {
                this.loadError = "Não foi possível carregar os detalhes do monitoramento.";
            } finally {
                this.busy = false;
            }
        },

    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/monitoramento`);
        this.$leitorService = new ResourceService(`/api/leitor`);

        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamento = brand && brand.departamento ? brand.departamento : {};
        this.load();
    },

}
</script>

<style scoped>
.is-disabled {
    opacity: .5;
    filter: grayscale(30%);
    user-select: none;
}

.filter-row {
    margin-bottom: 12px;
}

.pagination-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-top: 12px;
    border-top: 1px solid #e9ecef;
}
</style>
